const sharingDetailsReducer = ( state = {
	findCollaborators: null,
	enteredCollaboratorSearchValue: "",
	selectedCollaborator: null,
	collaboratorsPageNumber: 1,
	collaboratorsPageSize: 20,
	getSharingDetailsPopup: [],
	getSharingDetailsLv2Popup: [],
	ownershipChangeTarget: null,
	getChangedStatus: false,
	autoCompleteLoading: false,
	getAutoComplete: "",
	autoCompleteEnteredValue: "",
    getSeveralCollaboratorsToAdd: null,
	getAddedCollaborators: [],
	rightToAdd: 'READ_ONLY',
	addToContactSwitch: true,
	invalidShare:false,
	updateCollaborators: [],
	getDeletedCollaborators: [],
	flash: null,
	sharedWithMeDisplayMode: false,
	isNewAddedCollaboratorsLoading: false,
	notify: true,
	updatingCollaborators: false,
	showHiddenFields: false,
	isHiddenFieldsChanging: false,
	hiddenFieldsUpdate: {},
	isSharing: false
}, action ) => {
	switch (action.type){
        case "FIND_COLLABORATORS":
            state = {
                ...state,
	            findCollaborators: action.payload
            };
            break;
		case "FIND_NEXT_COLLABORATORS":
			state = {
				...state,
				findCollaborators: {
					...state.findCollaborators,
					collaborators: [
						...state.findCollaborators.collaborators,
						...action.payload.collaborators
					]
				}
			};
			break;
        case "REFRESH_COLLABORATORS":
            state = {
                ...state,
                findCollaborators: {
                    ...state.findCollaborators,
                    collaborators: [...state.findCollaborators.collaborators, ...action.payload]
                }
            };
            break;
		case "ENTERED_COLLABORATOR_SEARCH_VALUE":
			state = {
				...state,
				enteredCollaboratorSearchValue: action.payload
			};
			break;
        case "LOAD_PREV_COLLABORATORS":
            state = {
                ...state,
                findCollaborators: {
                    ...state.findCollaborators,
                    collaborators: action.payload
                }
            };
            break;
        case "LOAD_NEXT_COLLABORATORS":
            state = {
                ...state,
                findCollaborators: {
                    ...state.findCollaborators,
                    collaborators: [...state.findCollaborators.collaborators, ...action.payload]
                }
            };
            break;
		case "SELECTED_COLLABORATOR":
			state = {
				...state,
				selectedCollaborator: action.payload
			};
			break;
        case "COLLABORATORS_PAGE_NUMBER":
            state = {
                ...state,
                collaboratorsPageNumber: action.payload
            };
            break;
		case "COLLABORATORS_PAGE_SIZE":
			state = {
				...state,
				collaboratorsPageSize: action.payload
			};
			break;
		case "GET_SHARING_POPUP":
			state = {
				...state,
				getSharingDetailsPopup: action.payload
			};
			break;
        case "GET_SHARING_LV2_POPUP":
            state = {
                ...state,
                getSharingDetailsLv2Popup: action.payload
            };
            break;
		case "OWNERSHIP_CHANGE_TARGET":
			state = {
				...state,
				ownershipChangeTarget: action.payload
			};
			break;
		case "GET_CHANGED_STATUS":
			state = {
				...state,
				getChangedStatus: action.payload
			};
			break;
		case "AUTO_COMPLETE_LOADING":
			state = {
				...state,
				autoCompleteLoading: action.payload
			};
			break;
		case "GET_AUTO_COMPLETE":
			state = {
				...state,
				getAutoComplete: action.payload
			};
			break;
		case "AUTO_COMPLETE_ENTERED_VALUE":
			state = {
				...state,
				autoCompleteEnteredValue: action.payload
			};
			break;
        case "GET_SEVERAL_COLLABORATORS_TO_ADD":
            state = {
                ...state,
                getSeveralCollaboratorsToAdd: action.payload
            };
            break;
		case "REMOVE_THE_LAST_ADDED_COLLABORATOR":
			state = {
				...state,
				getAddedCollaborators: state.getAddedCollaborators.slice(0, state.getAddedCollaborators.length - 1)
			};
			break;
		case "GET_ADDED_COLLABORATORS":
			state = {
				...state,
				getAddedCollaborators: [...state.getAddedCollaborators, action.payload]
			};
			break;
        case "UPDATE_ADDED_COLLABORATORS":
            state = {
                ...state,
                getAddedCollaborators: action.payload
            };
            break;
        case "RIGHT_TO_ADD":
            state = {
                ...state,
                rightToAdd: action.payload
            };
            break;
		case "RESET_ADDED_COLLABORATORS":
            state = {
                ...state,
                getAddedCollaborators: []
            };
            break;
		case "UPDATE_COLLABORATORS":
			state = {
				...state,
				updateCollaborators: action.payload
			};
			break;
		case "ADD_TO_CONTACT_SWITCH":
			state = {
				...state,
				addToContactSwitch: action.payload
			};
			break;
		case "INVALID_SHARE":
			state = {
				...state,
				invalidShare: action.payload
			};
			break;
		case "GET_DELETED_COLLABORATORS":
			state = {
				...state,
				getDeletedCollaborators: [...state.getDeletedCollaborators, action.payload]
			};
			break;
		case "GET_INIT_DELETED_COLLABORATORS":
			state = {
				...state,
				getDeletedCollaborators: []
			};
			break;
		case "FLASH":
			state = {
				...state,
				flash: action.payload
			};
			break;
		case "SHARED_WITH_ME_DISPLAY_MODE":
			state = {
				...state,
				sharedWithMeDisplayMode: action.payload
			};
			break;
		case "IS_NEW_ADDED_COLLABORATORS_LOADING":
			state = {
				...state,
				isNewAddedCollaboratorsLoading: action.payload
			};
			break;
		case "NOTIFY":
			state = {
				...state,
				notify: action.payload
			};
			break;
		case "UPDATING_COLLABORATORS":
			state = {
				...state,
				updatingCollaborators: action.payload
			};
			break;
		case "SHOW_HIDDEN_FIELDS":
			state = {
				...state,
				showHiddenFields: action.payload
			};
			break;
		case "IS_HIDDEN_FIELDS_CHANGING":
			state = {
				...state,
				isHiddenFieldsChanging: action.payload
			};
			break;
		case "HIDDEN_FIELDS_UPDATE":
			state = {
				...state,
				hiddenFieldsUpdate: action.payload
			};
			break;
		case "IS_HIDDEN_FIELDS_UPDATING":
			state = {
				...state,
				isHiddenFieldsUpdating: action.payload
			};
			break;
		case "IS_SHARING":
			state = {
				...state,
				isSharing: action.payload
			};
			break;
		default :
			break;
	}
	return state;
};

export default sharingDetailsReducer;
